import React from "react";
import { Tabs, Tab, Tooltip, Box } from "@mui/material";
import MDBox from "components/MDBox";

function TrafficBar({ data, selectedData, setSelectedData }) {
  // only show the first 20 items
  const sLdata = data.slice(0, 20);

  // build an array of the ids we actually rendered
  const visibleIds = sLdata.map((area) => area.id);

  // if selectedData.id is still in that list, use it; otherwise fall back to the first visible id
  const currentValue = visibleIds.includes(selectedData?.id)
    ? selectedData.id
    : visibleIds[0] ?? 0;

  const handleChange = (_, newValue) => {
    const found = data.find((area) => area.id === newValue);
    if (found) {
      setSelectedData(found);
    }
  };

  return (
    <Box
      // sx={{
      //   maxWidth: { xs: 900, sm: 480 },
      // }}
    >
      <Tabs
        value={currentValue}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable tabs"
        sx={{
          width: "100%",
          "& .MuiTabs-scroller": {
            overflowX: "auto !important",
          },
          "& .MuiTabs-flexContainer": {
            flexWrap: "nowrap",
          },
          "& .MuiTabs-scrollButtons": {
            display: "flex",
            color: "#fff",
          },
          "& .MuiTabs-scrollButtons.Mui-disabled": {
            opacity: 0.3,
          },
        }}
      >
        {sLdata.map((area) => (
          <Tooltip key={area.id} title={area.title} arrow>
            <Tab
              label={area.title}
              value={area.id}
              sx={{
                // textTransform: "none",
                // // minWidth: "160px", // Increase to show more
                // // maxWidth: "300px", // Optional: loosen restriction
                // whiteSpace: "normal", // ✅ allow line wrap
                // textAlign: "center", // ✅ center multiline text
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
              }}
            />
          </Tooltip>
        ))}
      </Tabs>
    </Box>
  );
}

export default React.memo(TrafficBar);
